import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-box',
  imports: [CommonModule],
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
})
export class InfoBoxComponent implements OnInit {
  @Input() title = '';
  public className: string;

  ngOnInit() {
    this.className = this.title.toLowerCase().replace(/\s+/g, '-');
  }
}
